module.exports = function strip (html) {
    return typeof html === 'string'
        ? html
            .replace(/\<[^\>]*\>/g, ' ')
            .replace(/&nbsp;/g, ' ')
            .replace(/[\s\t\r\n]+/g, ' ')

        : '';
}